import React, { useEffect, useState } from 'react';
import * as S from './Styled';
import Icon from '../Icon';
import Spinner from '../Spinner';
import CityPopover from '../CityPopover';
import {
  selectLocation,
  setLocationConfirmed,
  TheBehaviorDrawer,
} from '../../actions';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Cities } from '../Header/modals';
import { useMediaQuery } from 'react-responsive';

export default ({
  location,
  isLoading,
  onChange,
  placement = 'left',
  outsideClickIgnoreClass = false,
  navVisible,
  ...rest
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [, setCitiesPopIsVisible] = useState(false);
  const locationConfirmed = useSelector(state => state.user.locationConfirmed);
  const isMob = useMediaQuery({ query: '(max-width: 767px)' });
  const [cities, setCities] = useState(false);
  const [popover, setPopover] = useState(false);

  useEffect(() => {
    let timer = setTimeout(() => {
      if (!locationConfirmed) {
        setPopover(true);
      }
    }, 2000);
    return () => {
      clearTimeout(timer);
    };
  }, [locationConfirmed]);

  const onChangeCity = event => {
    event.preventDefault();
    event.stopPropagation();
    dispatch(TheBehaviorDrawer(false));
    setPopover(false);
    setCities(true);

    if (onChange) {
      onChange();
    }
  };

  const onSelectCity = async item => {
    let location = {
      ...item,
      name: item?.address?.split(',')?.[0] ?? item?.name,
    };
    await dispatch(selectLocation(location));
    setCitiesPopIsVisible(false);
    dispatch(TheBehaviorDrawer(false));
    setCities(false);
  };

  return (
    <>
      {isMob && !navVisible ? (
        <>
          <CityPopover
            onChangeCity={onChangeCity}
            confirmLocation={() => dispatch(setLocationConfirmed(true))}
            location={location}
            locationConfirmed={locationConfirmed}
            _popover={[popover, setPopover]}
          />
        </>
      ) : null}

      <S.Location {...rest}>
        <S.LocationCont
          onClick={() => {
            setPopover(true);
          }}
        >
          <Icon name="location" />
          {isLoading ? (
            <Spinner />
          ) : location ? (
            <S.City className="location-city">{location?.name}</S.City>
          ) : (
            t('labels.not_defined')
          )}
        </S.LocationCont>

        {!isMob ? (
          <CityPopover
            placement={placement}
            onChangeCity={onChangeCity}
            confirmLocation={() => dispatch(setLocationConfirmed(true))}
            location={location}
            locationConfirmed={{}}
            _popover={[popover, setPopover]}
            outsideClickIgnoreClass={outsideClickIgnoreClass}
          />
        ) : null}
      </S.Location>

      {cities ? (
        <Cities
          isLoading={isLoading}
          visible={cities}
          onOk={onSelectCity}
          onCancel={() => {
            if (!isLoading) {
              setCities(false);
            }
          }}
          location={location}
        />
      ) : null}
    </>
  );
};
